const config = {
    API_BASE_URL: "http://ec2-13-60-218-109.eu-north-1.compute.amazonaws.com",
    // API_BASE_URL: "https://dentalserver.online",

}


export default config;